import { create } from '@mui/material/styles/createTransitions';
import axiosClient from './axiosClient';

const marketCategoryService = {
    get: async (id) => {
        const response = await axiosClient.get(`/public/market-categories/${id}`);
        return response.data;
    },
    all: async () => {
        const response = await axiosClient.get('/public/market-categories');
        return response.data;
    },
    adminAll: async () => {
        const response = await axiosClient.get('/admin/market-categories');
        return response.data;
    },

    // admin only:
    create: async (categoryData) => {
        const response = await axiosClient.post('/admin/market-categories', categoryData);
        return response.data;
    },
    update: async (id, categoryData) => {
        const response = await axiosClient.put(`/admin/market-categories/${id}`, categoryData);
        return response.data;
    },
    delete: async (id) => {
        const response = await axiosClient.delete(`/admin/market-categories/${id}`);
        return response.data;
    }
};

export default marketCategoryService;
